<template>
  <div class="mb-3">
    <input
      :type="type"
      class="form-control rounded-3 base-input, inputClass"
      :id="id"
      v-model="inputValue"
      @input="emitInput"
    />
  </div>
</template>

<script>
export default {
  name: "BaseInput",
  props: {
    inputClass: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text", // 默认为文本输入框
    },
    id: {
      type: String,
      default: "", // 默认没有 id
    },
    value: {
      type: String,
      default: "", // 用于 v-model 双向绑定
    },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
  methods: {
    emitInput() {
      this.$emit("input", this.inputValue);
    },
  },
  watch: {
    value(newVal) {
      this.inputValue = newVal;
    },
  },
};
</script>

<style>
/* 默认样式适用于iPad mini以上到电脑屏幕 */
.base-input {
  width: 300px; /* 较大屏幕上的固定宽度 */
}

/* 手机屏幕 */
@media (max-width: 576px) {
  .base-input {
    width: 200px; /* 手机屏幕上的固定宽度 */
  }
}
</style>
